<template>
    <v-dialog v-model="dialogueProp" width="1200" scrollable>
        <v-card>
            <v-toolbar class="close-btn" flat>
                <v-btn icon @click="dialogueProp = false">
                    <v-icon>{{ mdiClose }}</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider />
            <div v-if="getDependentEHB" class="util-container">
                <!-- Dependent EHB AR -->
                <div style="width:85%; margin:auto;">
                    <div v-if="dependentSelection === cardCount">
                        <div class="text-center mt-5">
                            <h3>{{ dependentName }}</h3>
                        </div>
                        <br>
                        <div v-if="getDependentEHB">
                            <div v-if="getDependentEHB.info.TAR > 0">
                                <v-data-table
                                    :headers="headers"
                                    :items="getData"
                                    :items-per-page="5"
                                    no-data-text
                                    :footer-props="footer_props"
                                    class="my-10 elevation-10"
                                    :class="{ mobile: screen_width < 968 }"
                                >
                                    <template #item="{ item }">
                                        <tr v-if="screen_width < 600">
                                            <td colspan="7">
                                                <ul class="flex-content">
                                                    <div class="content d-flex justify-space-between" style="width:100%">
                                                        <label>Debit Memo #.:</label>
                                                        <li class="flex-item" data-label="Calories">
                                                            {{ item.DMNO_N }}
                                                        </li>
                                                    </div>
                                                    <div class="content d-flex justify-space-between" style="width:100%">
                                                        <label>Date:</label>
                                                        <li class="flex-item" data-label="Calories">
                                                            {{ item.DMDA_D }}
                                                        </li>
                                                    </div>
                                                    <div class="content d-flex justify-space-between" style="width:100%">
                                                        <label>EHB:</label>
                                                        <li class="flex-item" data-label="Calories">
                                                            {{ item.DUEH_A }}
                                                        </li>
                                                    </div>
                                                    <div class="content d-flex justify-space-between" style="width:100%">
                                                        <label>PH:</label>
                                                        <li class="flex-item" data-label="Calories">
                                                            {{ item.DUME_A }}
                                                        </li>
                                                    </div>
                                                    <div class="content d-flex justify-space-between" style="width:100%">
                                                        <label>EHB(PAID):</label>
                                                        <li class="flex-item" data-label="Calories">
                                                            {{ item.PAEH_A }}
                                                        </li>
                                                    </div>
                                                    <div class="content d-flex justify-space-between" style="width:100%">
                                                        <label>PH(PAID):</label>
                                                        <li class="flex-item" data-label="Calories">
                                                            {{ item.PAME_A }}
                                                        </li>
                                                    </div>
                                                    <div class="content d-flex justify-space-between" style="width:100%">
                                                        <label>Remarks:</label>
                                                        <li class="flex-item" data-label="Calories">
                                                            {{ item.REMA_M }}
                                                        </li>
                                                    </div>
                                                </ul>
                                            </td>
                                        </tr>
                                        <tr v-else>
                                            <td v-text="item.DMNO_N"></td>
                                            <td v-text="item.DMDA_D"></td>
                                            <td v-text="item.DUEH_A"></td>
                                            <td v-text="item.DUME_A"></td>
                                            <td v-text="item.PAEH_A"></td>
                                            <td v-text="item.PAME_A"></td>
                                            <td v-text="item.REMA_M"></td>
                                        </tr>
                                    </template>
                                    <!--
                                <template slot="item" slot-scope="props">
                                    <tr>
                                    <td v-text="props.item.DMNO_N" />
                                    <td v-text="props.item.DMDA_D" />
                                    <td v-text="props.item.DUEH_A" />
                                    <td v-text="props.item.DUME_A" />
                                    <td v-text="props.item.PAEH_A" />
                                    <td v-text="props.item.PAME_A" />
                                    <td v-text="props.item.REMA_M" />
                                    </tr>
                                </template>
                                -->
                                </v-data-table>
                                Outstanding Balance as of {{ moment().utcOffset('+0800').format("DD MMMM YYYY") }} <br>
                                <br>
                                <v-divider />
                                <br>
                                <div class="row">
                                    <div class="col d-flex">
                                        Excess Hospital Bills:
                                    </div>
                                    <div class="col d-flex">
                                        PHP {{ (getDependentEHB.info.TEHB) ? (getDependentEHB.info.TEHB).toFixed(2) : '0.00' }}
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col d-flex">
                                        PhilHealth:
                                    </div>
                                    <div class="col d-flex">
                                        PHP {{ (getDependentEHB.info.TPH) ? (getDependentEHB.info.TPH).toFixed(2) : '0.00' }}
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col d-flex">
                                        Total:
                                    </div>
                                    <div class="col d-flex">
                                        PHP {{ (getDependentEHB.info.TAR) ? (getDependentEHB.info.TAR).toFixed(2) : '0.00' }}
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col d-flex">
                                        Interest:
                                    </div>
                                    <div class="col d-flex">
                                        PHP {{ (getDependentEHB.info.TINT) ? (getDependentEHB.info.TINT).toFixed(2) : '0.00' }}
                                    </div>
                                </div>
                                <br>
                                <v-divider />
                                <br>
                                For more information, please contact HMI.
                                <br>
                                <br>
                            </div>
                            <div v-else>
                                As of {{ moment().utcOffset('+0800').format("DD MMMM YYYY") }}, this dependent has no excess hospital bills to pay to HMI. Thank you!
                                <br>
                                <br>
                            </div>
                            <div style="background-color: white; padding: 3px; border-radius: 5px;">
                                <v-alert
                                    color="teal darken-3"
                                    outlined
                                    style="margin: 0;"
                                    type="info"
                                >
                                    <span>Note: The information reported on this page is not displayed in real time, and still subject to succeeding updates.</span>
                                </v-alert>
                            </div>
                            <br>
                        </div>
                    </div>
                </div>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import { mdiClose } from '@mdi/js'
import { moment } from '../../../utils/date-shim'

export default {
    props: [
        'getDependentEHB',
        'dependentSelection',
        'cardCount',
        'dependentName',
        'showDependentEHB'
    ],
    data: () => {
        return({
            mdiClose,
            screen_width: document.documentElement.clientWidth + 9,
            AR: null,
            footer_props: {
                'items-per-page-options': []
            },
            headers: [
                {
                    text: 'Debit Memo No.',
                    align: 'left',
                    value: 'DMNO_N',
                    class: 'teal--text'
                },
                {
                    text: 'Date',
                    align: 'left',
                    value: 'DMDA_D',
                    class: 'teal--text'
                },
                {
                    text: 'EHB',
                    align: 'left',
                    value: 'DUEH_A',
                    class: 'teal--text'
                },
                {
                    text: 'PH',
                    align: 'left',
                    value: 'DUME_A',
                    class: 'teal--text'
                },
                {
                    text: 'PAID EHB',
                    align: 'left',
                    value: 'PAEH_A',
                    class: 'teal--text'
                },
                {
                    text: 'PAID PH',
                    align: 'left',
                    value: 'PAME_A',
                    class: 'teal--text'
                },
                {
                    text: 'Remarks',
                    align: 'left',
                    value: 'REMA_M',
                    class: 'teal--text'
                }
            ]
        })
    },
    computed: {
        getData: {
            get() {
                let row = this.getDependentEHB.info.ROW
                let data = []
                if (row) {
                    for (var i = 0; i < row.length; i++) {
                        data.push({
                            DMNO_N: row[i].DMNO_N,
                            DMDA_D: moment(row[i].DMDA_D).utcOffset('+0800').format('DD MMM YY'),
                            DUEH_A: `PHP ${(row[i].DUEH_A) ? (row[i].DUEH_A).toFixed(2) : '0.00'}`,
                            DUME_A: `PHP ${(row[i].DUME_A) ? (row[i].DUME_A).toFixed(2) : '0.00'}`,
                            PAEH_A: `PHP ${(row[i].PAEH_A) ? (row[i].PAEH_A).toFixed(2) : '0.00'}`,
                            PAME_A: `PHP ${(row[i].PAME_A) ? (row[i].PAME_A).toFixed(2) : '0.00'}`,
                            REMA_M: row[i].REMA_M
                        })
                    }
                }
                return data
            }
        },
        dialogueProp: {
            get() {
                return this.showDependentEHB && this.cardCount === this.dependentSelection
            },
            set(val) {
                this.$emit('showDialog', val)
            }
        }
    },
    mounted() {
        window.addEventListener('resize', this.onResize)
    },
    destroyed() {
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        onResize() {
            this.screen_width = document.documentElement.clientWidth
        }
    }
}
</script>
<style scoped>
.close-btn{
  display: flex;
  align-items: right;
  justify-content: right;
}

.util-container {
  background-color:white;
}

.requestWrapper {
    height: 10;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
}

section {
  width: 100%;
  background-image: url("../../../assets/dashboardBG.webp");
  background-position: center;
  background-size: cover;
}
.user-card {
  width: 95%;
}

.flex-content {
    padding: 0;
    margin: 10px auto;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
}

.flex-item {
    padding: 5px;
    width: 100%;
    height: 40px;
    text-align: right;
}

@media (max-width: 599px) {
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }

  /* Member Card wrapper */
  .user-card {
    width: 100%;
  }
}

@media (min-width: 599px) and (max-width: 968px) {
  .user-card {
    width: 80%;
  }
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
}

@media (min-width: 968px) and (max-width: 1264px) {
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
}
</style>
